import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { styled } from "@mui/system";
import BryxColors from "../types/theme";
import { MenuItem, Select, SvgIcon } from "@mui/material";
import { BryxBox } from "./index";
import withStaticMode from "../hocs/withStaticMode";
import { dropKeys } from "@bryxinc/ts-utils";
import withLabel from "../hocs/withLabel";
import { useDefer } from "../hooks";
const BryxDropdown = styled(({ sx, label, iconViewbox, onChange, disableUnselect, disablePortal, children, className, ...rest }) => {
    const [isTextHovered, setIsTextHovered] = useState(false);
    const palette = "light";
    const brand1 = BryxColors.brand1(palette);
    const notifyInactive = BryxColors.notify(palette, "inactive");
    const deferBlur = useDefer((_) => {
        document.activeElement.blur();
    });
    return (_jsx(BryxBox, { sx: sx, className: className, children: _jsxs(Select, { ...dropKeys(rest, ["noBorder", "hideLabel"]), className: className, sx: {
                "& *": {
                    color: isTextHovered ? brand1 : notifyInactive,
                    borderColor: isTextHovered ? brand1 : notifyInactive,
                    transform: "200ms",
                    zIndex: 999999,
                },
            }, size: "medium", IconComponent: () => (_jsx(SvgIcon, { viewBox: iconViewbox ?? "-4 0 16 6", sx: {
                    position: "absolute",
                    right: "8px",
                    cursor: "pointer",
                    width: "16px",
                    height: "16px",
                    pointerEvents: "none",
                }, children: _jsx("path", { d: "M1.22595 0.722096L4.00358 3.66819L6.78121 0.722096C7.0604 0.425968 7.51141 0.425968 7.7906 0.722096C8.0698 1.01822 8.0698 1.49658 7.7906 1.79271L4.5047 5.2779C4.2255 5.57403 3.7745 5.57403 3.4953 5.2779L0.209396 1.79271C-0.0697987 1.49658 -0.0697987 1.01822 0.209396 0.722096C0.488591 0.433561 0.946756 0.425968 1.22595 0.722096Z" }) })), onChange: onChange, onClose: () => deferBlur(null), MenuProps: disablePortal
                ? {
                    disablePortal: true,
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "center",
                    },
                    sx: {
                        zIndex: 9999999,
                    },
                }
                : undefined, children: [!disableUnselect && _jsx(MenuItem, { value: "", children: "None" }), children] }) }));
})(({ theme, noBorder, disablePortal }) => {
    const palette = theme.palette.mode;
    const brand1 = BryxColors.brand1(palette);
    const brand4 = BryxColors.brand4(palette);
    const brandDark2 = BryxColors.brandDark2(palette);
    const notifyInactive = BryxColors.notify(palette, "inactive");
    return {
        width: "167px",
        cursor: "pointer",
        color: notifyInactive,
        "& .MuiInputBase-root": { height: "46px" },
        "& ~ .MuiTypography-root": {
            color: notifyInactive,
            "&:hover": {
                color: brand1,
            },
        },
        "&:has(+ .MuiFormLabel-root:hover) *": {
            color: brand1,
            borderColor: brand1,
            fill: brand1,
        },
        "& > .MuiSvgIcon-root": {
            transition: "transform 200ms",
            transform: "rotate(0deg)",
            "&:hover": {
                color: brand1,
            },
        },
        "& .MuiSelect-select": {
            border: "none",
        },
        "& .MuiOutlinedInput-notchedOutline": {
            border: `1px solid ${notifyInactive}`,
        },
        // Focus (clicked and/or open)
        "&.Mui-focused, &.Mui-focused > *": {
            color: palette == "light" ? brandDark2 : brand4,
            borderColor: palette == "light" ? brandDark2 : brand4,
            fill: palette == "light" ? brandDark2 : brand4,
        },
        "&.Mui-focused > .MuiSvgIcon-root, &[aria-expanded=true] > .MuiSvgIcon-root": {
            transform: "rotate(-180deg)",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: `1px solid ${palette == "light" ? brandDark2 : brand4}`,
        },
        "&.Mui-focused ~ .MuiFormLabel-root": {
            color: palette == "light" ? brandDark2 : brand4,
        },
        // Hover, not focused
        "&:hover": {
            color: brand1,
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            color: brand1,
            borderColor: brand1,
        },
        "&:hover .MuiSelect-iconOutlined": {
            fill: brand1,
        },
        "&:hover ~ .MuiFormLabel-root": {
            color: brand1,
        },
        // Hover and focused
        "&.Mui-focused:hover, &.Mui-focused:hover > *": {
            color: brand1,
            borderColor: brand1,
            fill: brand1,
        },
        "& .MuiPaper-root": disablePortal
            ? {
                transform: "translateX(-38px) !important",
            }
            : undefined,
    };
});
export default withStaticMode(withLabel(BryxDropdown));
